// src/components/RoomHeader.jsx
import React from "react";

const RoomHeader = ({ roomId, myEmail, connected, participantCount, logo, isAdminViewer }) => {
  return (
    <div className="room-header">
      <div className="room-headerLeft">
        <img src={logo} alt="Logo" className="room-logo" />

        <div className="room-roomInfoGrid">
          <div className="room-roomTag">
            LIVE ROOM: <strong>{roomId}</strong>
          </div>

          <div className="room-row">
            <div className="room-statusWrapper">
              <div
                className={
                  "room-statusPill " +
                  (connected ? "room-statusPill--connected" : "")
                }
              >
                <span
                  className={
                    "room-statusDot " +
                    (connected ? "room-statusDot--connected" : "")
                  }
                />
                {connected ? "Connected" : "Waiting"}
              </div>
              <div className="room-participantsPill">
                👥 {participantCount}{" "}
                {participantCount === 1 ? "participant" : "participants"}
              </div>
            </div>
          </div>

          <div className="room-userLine">
            You: <span>{myEmail || "Guest"}</span>
             {isAdminViewer && (
    <span
      style={{
        marginLeft: 8,
        padding: "2px 8px",
        borderRadius: 999,
        fontSize: 10,
        textTransform: "uppercase",
        letterSpacing: "0.12em",
        background: "rgba(56,189,248,0.16)",
        border: "1px solid rgba(56,189,248,0.8)",
        color: "#7dd3fc",
      }}
    >
      Admin view
    </span>
  )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomHeader;
